import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-dropdown-button',
  standalone: true,
  imports: [],
  templateUrl: './dropdown-button.component.html',
  styleUrl: './dropdown-button.component.scss'
})
export class DropdownButtonComponent {

  @Input()
  dropList: { key: string; label: string; }[] = [];

  @Input()
  defaultSelection: string = '';

  @Output()
  selectElement: EventEmitter<{ key: string; label: string; }> = new EventEmitter();


}
